import React, { useEffect, useState } from 'react'
import { ITheme } from 'application/utils/type'
import ChecklistCard from './checklistCard'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'
import {
  IDatablock,
  IStaticDataItem,
} from './proposalInterfaces/cardStaticDataTypes'

/*TODO 
  Fix up UpdateChecked to not use props.errorList
*/

interface IChecklistSectionProps {
  checklistData: any
  updateErrors(array: ILocalError[], msg: string): any
  inErrorState: boolean
  errorList: any
  id: string
  theme: ITheme
}

interface ILocalError {
  id: string
  cardNumber: number
}

const ChecklistSection = (props: IChecklistSectionProps) => {
  var checklistData = props.checklistData

  useEffect(() => {
    initialiseUnchecked()
  },[] )

  const [unchecked, setUnchecked] = useState<ILocalError[]>([])

  const initialiseUnchecked = () => {
    //push every checkbox item into unchecked array
    let tmpArray: ILocalError[] = []

    checklistData.forEach((c: IStaticDataItem) => {
      c.datablocks.forEach((db: IDatablock) => {
        db.checklistItems.forEach((i) => {
          tmpArray.push({ id: i.id, cardNumber: c.cardNumber })
        })
      })
    })
    setUnchecked(tmpArray)
    props.updateErrors(
      tmpArray,
      'You must have read and agree to all the above points in the orange boxes to proceed with proposal'
    )
  }

  const createAnchorForPoint = (tagId: string) => {
    return (
      '<a style="color:inherit; text-decoration: underline;" onClick="return handleSubMenuBarScroll()" href="#' +
      tagId.toString().replace(/ /g, '') +
      '">' +
      tagId +
      '</a>'
    )
  }

  const CheckErrors = () => {
    //Set card errors from i) unchecked (for first run thru), or ii) props.errorList (for subsequent runs)
    if (props.inErrorState) {
      setUnchecked(props.errorList)
      //Update errors on each of the cards
    }
    checklistData.forEach((c: any) => {
      c.errors = unchecked
        .filter((x) => x.cardNumber === c.cardNumber)
        .map((x) => x.id)
    })

    var errMessage = ''
    if (unchecked.length > 0) {
      if (
        Math.max.apply(
          Math,
          unchecked.map((o) => o.cardNumber)
        ) !==
        Math.min.apply(
          Math,
          unchecked.map((o) => o.cardNumber)
        )
      ) {
        // Errors on multiple cards
        errMessage =
          'You must have read and agree to all the above points in the orange boxes to proceed with proposal'
      } else {
        //Errors only a single card
        var card = checklistData.find(
          (c: IStaticDataItem) => c.cardNumber === unchecked[0].cardNumber
        )
        var thePoints
        if (card.cardNumber !== 1) thePoints = 'all points'
        else {
          switch (unchecked.length) {
            case 1:
              thePoints = 'point ' + createAnchorForPoint(unchecked[0].id)
              break
            case 2:
              thePoints =
                'point ' +
                createAnchorForPoint(unchecked[0].id) +
                ' and ' +
                createAnchorForPoint(unchecked[1].id)
              break
            case 3:
              thePoints =
                'point ' +
                createAnchorForPoint(unchecked[0].id) +
                ', ' +
                createAnchorForPoint(unchecked[1].id) +
                ' and ' +
                createAnchorForPoint(unchecked[2].id)
              break
            default:
              thePoints = 'all points'
          }
        }

        errMessage =
          'You must read and agree to ' +
          thePoints +
          ' in the ' +
          (thePoints === 'all points'
            ? createAnchorForPoint(card.title)
            : card.title) +
          ' section to proceed with proposal'
      }
    }
    props.updateErrors(unchecked, errMessage)
  }

  const UpdateChecked = (id: string, value: boolean, cardNumber: number) => {
    let item: ICardChecklistItemProps | undefined
    const card = checklistData.find(
      (c: IStaticDataItem) => c.cardNumber === +cardNumber
    )
    card.datablocks.every((db: IDatablock) => {
      item = db.checklistItems.find((e) => e.id === id)
      if (item) {
        return false
      }
      return true
    })

    if (item) item.isChecked = value
    /* Not happy about altering props.errorList here, but can't see another easy way to do it.

    If we've already run the check once, and the user has ticked a box then find the item in props.errorList and remove it
    If we've already run the check once, and the user has unticked another box, and we don't already have this item in the error list 
    then add this item to the errorList
    */
    if (props.inErrorState) {
      if (value) {
        for (var i = 0; i < props.errorList.length; i++) {
          if (
            props.errorList[i].cardNumber === cardNumber &&
            props.errorList[i].id === id
          ) {
            props.errorList.splice(i, 1)
            break
          }
        }
      } else if (
        !value &&
        !props.errorList.find(
          (e: ILocalError) => e.cardNumber === cardNumber && e.id === id
        )
      ) {
        props.errorList.push({ id: id, cardNumber: cardNumber })
      }
    } else {
      //Not inErrorState
      let tmpArray = unchecked
      if (value) {
        //remove from unchecked
        for (i = 0; i < tmpArray.length; i++) {
          if (tmpArray[i].cardNumber === cardNumber && tmpArray[i].id === id) {
            tmpArray.splice(i, 1)
            break
          }
        }
      } else {
        //checkbox cleared, add back into unchecked, (confirm it's not already in there)
        if (!tmpArray.find((e) => e.cardNumber === cardNumber && e.id === id))
          tmpArray.push({ id: id, cardNumber: cardNumber })
      }
      setUnchecked(tmpArray)
    }
    CheckErrors()
  }

  return (
    <div id={props.id}>
      {checklistData.map((card: IStaticDataItem) => {
        return (
          <ChecklistCard
            id={card.title.replace(/ /g, '')}
            data={card}
            UpdateChecked={UpdateChecked}
            errorList={props.errorList}
            headingNumber={card.cardHeadingNumber}
            theme={props.theme}
          />
        )
      })}
    </div>
  )
}

export default ChecklistSection
